import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ROUTES } from "@/constants/routes";
import { FullScreenLoader } from "@/components/organisms/FullScreenLoader";

/**
 * Tela Splash: mostra a identidade animada por um instante e verifica
 * automaticamente o login, encaminhando para Home ou Login.
 */
export function SplashPage() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    const timeout = setTimeout(() => {
      navigate(isAuthenticated ? ROUTES.home : ROUTES.login, { replace: true });
    }, 700);

    return () => clearTimeout(timeout);
  }, [isAuthenticated, isLoading, navigate]);

  return <FullScreenLoader />;
}
